<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}件商品</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in cartInfo"
        :key="cart.id"
      >
        <div class="pictrue">
          <img v-lazy="cart.productInfo.image" alt="img" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.productInfo.store_name }}</div>
            <div class="num">x {{ cart.cart_num }}</div>
          </div>

          <div class="money">
            {{shop_type==3 ?'':'￥'}}{{
              cart.productInfo.attrInfo
                ? cart.productInfo.attrInfo.price
                : cart.productInfo.price
            }}{{shop_type==3 ?'积分':''}}
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div>
          <div
            class="evaluate"
            v-if="evaluate === 3"
            @click="$router.push({ path: '/goods_evaluate/' + cart.unique })"
          >
            评价
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      shop_type:1
    };
  },
  mounted: function() {
    this.shop_type=this.$route.query.shop_type;
  },
  methods: {}
};
</script>
<style scoped>
.orderGoods {
  min-height: 100px;
  background: #ffffff;
  border-radius: 5px;
  margin: 16px 11px auto 11px;
}
.goodWrapper .item .text {
  width: 4.57rem;
}
.goodWrapper .item .pictrue {
  width: 96px;
  height: 96px;
}
.goodWrapper .item {
  height: 150px;
}
.acea-row {
  flex-wrap: nowrap;
}
.goodWrapper .item .text .name {
  width: 4rem;
}
.goodWrapper .item .text .money {
  font-size: 18px;
}
.goodWrapper .item .text .attr {
  background: #f8f8f8;
  border-radius: 2px;
  height: 26px;
  line-height: 26px;
  width: fit-content;
  padding: 0 10px;
  color: #999999;
}
.goodWrapper .item .text .name {
  font-size: 16px;
}
</style>
